<template>
  <div class="contact-form-wrapper">
    <transition name="fade-faster" mode="out-in">
      <div key="form-submitted" class="form-submitted-wrapper" v-if="formSubmitted">
        <div class="text-header-2">
          {{ $t('selectApptTimeStep.contactForm.success.text') }}
        </div>
        <div class="text-header-4">
          {{ $t('selectApptTimeStep.contactForm.success.subtext') }}
        </div>
      </div>

      <div key="form" v-else>
        <div class="form-group">
          <label class="form-label">
            {{ $t('selectApptTimeStep.contactForm.fullName') }}
          </label>
          <el-input :placeholder="$t('selectApptTimeStep.contactForm.fullNamePlaceholder')" v-model="name" />
        </div>

        <div class="form-group">
          <label class="form-label">
            {{ $t('selectApptTimeStep.contactForm.phone') }}
          </label>
          <el-input
            :placeholder="$t('selectApptTimeStep.contactForm.phonePlaceholder')"
            type="tel"
            v-model="phone"
            inputmode="tel"
            oninput="this.value = this.value.replace(/[^\d+]+/g, '').replace(/(\..*)\./g, '$1')"
          />
        </div>

        <div class="form-group">
          <label class="form-label">
            {{ $t('selectApptTimeStep.contactForm.message') }}
          </label>
          <el-input
            type="textarea"
            rows="4"
            :placeholder="$t('selectApptTimeStep.contactForm.messagePlaceholder')"
            v-model="message"
          />
        </div>

        <div class="text-body-5">
          {{ $t('selectApptTimeStep.contactForm.optInDisclaimer', { shopname }) }}
          <router-link :to="'/terms?shop=' + this.$route.query.shop" target="_blank">
            <span class="text-primary">{{ $t('general.termsAndConditions') }}</span>
          </router-link>
        </div>

        <transition name="fade-faster">
          <div class="mt-12px" v-if="error">
            <el-alert class="text-left" effect="dark" :title="error" type="error" />
          </div>
        </transition>
      </div>
    </transition>

    <transition name="fade-faster">
      <sticked-to-bottom-button
        @btn-click="submitContactForm"
        v-if="name && phone && message && !formSubmitted"
        :loading="loading"
      />
    </transition>
  </div>
</template>

<script>
import StickedToBottomButton from '@/components/global/StickedToBottomButton';

import CustomersService from '@/services/CustomersService';

export default {
  name: 'ContactForm',
  components: {
    StickedToBottomButton,
  },
  props: {
    shopname: {
      type: String,
      required: true,
    },
    accountSlug: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      name: '',
      phone: '',
      message: '',
      loading: false,
      error: '',
      formSubmitted: false,
    };
  },
  methods: {
    async submitContactForm() {
      try {
        this.error = null;
        this.loading = true;
        await CustomersService.post.contact(this.accountSlug, this.name, this.phone, this.message);
        this.loading = false;
        this.formSubmitted = true;
      } catch (error) {
        this.error = this.$t('errors.somethingWentWrong');
        this.loading = false;
      }
    },
  },
};
</script>

<style lang="scss">
.contact-form-wrapper {
  padding: 24px 0;

  .form-submitted-wrapper {
    text-align: center;
    padding: 64px 0;
  }
}
</style>
